import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const showSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    message: I18n.text('crmObjectBoardCard.alerts.success.description'),
    titleText: I18n.text('crmObjectBoardCard.alerts.success.title'),
    type: 'success',
    role: 'status'
  });
};
export const showFailureAlert = () => {
  FloatingAlertStore.addAlert({
    message: I18n.text('crmObjectBoardCard.alerts.failure.description'),
    titleText: I18n.text('crmObjectBoardCard.alerts.failure.title'),
    type: 'danger',
    role: 'status'
  });
};